import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Fires a GA4 `page_view` on every React-Router route change.
 *
 * GA4's inline snippet in index.html only sends the first pageview when
 * the SPA boots. Because we never do full page reloads after that, every
 * subsequent virtual page (e.g. /learn, /country/france, /quiz) needs an
 * explicit page_view event or GA will only ever see the landing page.
 *
 * Mount once inside <BrowserRouter>. Nothing rendered.
 */
export default function GAPageviewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Wait a tick so route-level useEffects can update document.title first.
    const t = setTimeout(() => {
      trackPageview(pathname + (search || ""), document.title);
    }, 0);
    return () => clearTimeout(t);
  }, [pathname, search]);

  return null;
}
